import React, { useState,useRef} from 'react'



function SynopsEditModal({shown,children,leftMargin}) {
  

  return shown ? (
    <div  className="modal-backdrop"  
       style={{top:'0px',width:'1440px',height:'100%',left:leftMargin,backgroundColor:'rgba(0,0,0,0.5)'}}
     > 
     
     
     </div>
  )
  : ''
}

export default SynopsEditModal